import { Pipe, PipeTransform } from '@angular/core';

import { ApiPrice } from '../models/Billing.model';

export interface StripeRecurringPayment {
  interval: string;
  interval_count: number;
  aggregate_usage: string | null;
  meter: string | null;
  trial_period_days: number | null;
  usage_type: string;
}

@Pipe({
    name: 'pricingInterval',
    standalone: false
})
export class PricingIntervalPipe implements PipeTransform {
  transform(value: StripeRecurringPayment | ApiPrice): string {
    if (!value) return '';

    return value.interval_count > 1
      ? value.interval_count + ' ' + `${value.interval}s`
      : value.interval;
  }
}
